import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLazyQuery } from '@apollo/client';
import { RadioButtons, Typography } from '@guildeducationinc/recess';
import { TEST_FILTER } from '@src/graphql/queries/filter';
import { EntityType } from '@src/types';
import { FilterBuilder, RuleTargetType, TrackableButton, emptyFilterGroup, useLocale, } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
export const RuleTargetFilter = (props) => {
    const { t } = useLocale();
    useEffect(() => {
        if (!props.rule.criteria || Object.keys(props.rule.criteria).length === 0) {
            props.onChange({
                ...props.rule,
                criteria: {
                    ...emptyFilterGroup,
                },
            });
        }
    }, []);
    const [testResult, setTestResult] = useState(null);
    const [testFilterQuery, testFilterResult] = useLazyQuery(TEST_FILTER);
    useEffect(() => {
        if (testFilterResult?.data) {
            setTestResult({
                found: testFilterResult.data.testFilter.found,
                total: testFilterResult.data.testFilter.total,
            });
        }
        if (testFilterResult?.error) {
            setTestResult({
                error: testFilterResult.error.message,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [testFilterResult]);
    const handleTestConditions = async () => {
        await testFilterQuery({
            variables: {
                input: {
                    name: '',
                    clientId: props.clientId,
                    id: null,
                    returnType: EntityType.EMPLOYEE,
                    criteria: props.rule.criteria,
                },
            },
        });
    };
    return (_jsxs("div", { className: 'flex flex-col border border-1 border-gray-300 my-2', children: [_jsx("div", { className: 'bg-gray-100 p-2', children: _jsx(Typography, { variant: 'title3', children: t('Applies To') }) }), _jsxs("div", { className: 'p-4', children: [_jsx("div", { className: 'inline-radio-buttons', children: _jsx(RadioButtons, { name: 'appliesTo', orientation: 'horizontal', groupLabel: t('Applies To'), hideGroupLabel: true, values: Object.keys(RuleTargetType).map(key => ({
                                label: t(`policyBuilder.targetPopulation.${key}`),
                                value: key.toString(),
                            })), selectedValue: props.rule.target, onChange: e => {
                                props.onChange({ ...props.rule, target: e.target.value });
                            } }) }), props.rule.target === RuleTargetType.FILTER && (_jsxs("div", { className: 'mt-4', children: [_jsxs("div", { className: 'flex mb-1', children: [_jsx(Typography, { variant: 'title3', children: t('Conditions') }), _jsxs("div", { className: 'grow text-right', children: [testResult && (_jsxs("span", { className: 'font-bold mr-1', children: [!testResult.error && (_jsx("span", { children: t('Found {found} out of {total} employees that matched these conditions', {
                                                            values: { found: testResult.found, total: testResult.total },
                                                        }) })), testResult.error && (_jsx("span", { className: 'text-red-600', children: t('Error running test. Verify that the conditions are completed and try again') }))] })), _jsx(TrackableButton, { btnType: 'mui', enText: 'Test Conditions', tag: props.type, variant: 'outlined', onClick: handleTestConditions, children: t('Test Conditions') })] })] }), _jsx(FilterBuilder, { clientId: props.clientId, criteria: props.rule.criteria ?? {
                                    ...emptyFilterGroup,
                                }, entityEnumType: props.targetPopulationEntityEnumType, onChange: criteria => props.onChange({ ...props.rule, criteria }), hideName: true, initialCondition: true, defaultEntityType: props.defaultTargetPopulationEntityType, customizedMessaging: true })] }))] })] }));
};
